module.exports = __webpack_public_path__ + "static/bootstrap-card-image-overlay-bd94c6065a9c5d643a066470375f2dd1.png";